if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.currentHandle = this.dataset.currentHandle;
        this.limit = parseInt(this.dataset.limit);
        this.slider = this.querySelector('slider-component');

        // --- INÍCIO DA CORREÇÃO ---
        // Pega o ID do cliente que passamos via Liquid (ou 'deslogado')
        this.customerId = this.dataset.customerId || 'deslogado';
        
        // Pega o último status de login que estava salvo no navegador
        const lastCustomerId = localStorage.getItem('theme:recently-viewed:customer');

        // Se o status mudou (ex: estava deslogado e agora fez login), limpamos o cache
        if (lastCustomerId && lastCustomerId !== this.customerId) {
          localStorage.removeItem('theme:recently-viewed');
          this.list = [];
        } else {
          // Se o status continua o mesmo, carregamos a lista normalmente
          const data = localStorage.getItem('theme:recently-viewed');
          this.list = JSON.parse(data) || [];
        }

        // Salva o status de login atual para a próxima verificação
        localStorage.setItem('theme:recently-viewed:customer', this.customerId);
        // --- FIM DA CORREÇÃO ---

        this.container = this.querySelector('.slider-component__grid');
      }

      connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
      }

      initializeRecommendations() {
        const filteredList = this.list.filter((item) => item.handle !== this.currentHandle);
        if (Shopify.designMode !== true && filteredList.length === 0) return;
        if (Shopify.designMode === true && filteredList.length !== 0) this.container.innerHTML = '';
        
        filteredList.forEach((item, index) => {
          if (this.container.children.length >= this.limit) return;
          const wrapper = document.createElement('li');
          wrapper.setAttribute('id', `Slide-${this.sectionId}-${index}`);
          wrapper.classList.add('slider-component__item');
          
          // Injeta o HTML (agora garantido de estar no contexto correto de login)
          wrapper.innerHTML = item.element; 
          
          this.container.appendChild(wrapper);
        });
        
        this.style.setProperty('--count', this.container.children.length);
        this.removeAttribute('hidden');
        this.slider?.mount();
      }
    }
  );
}